import React, { useEffect, useState, useContext } from 'react';
import TeamOverviewComponent from '../components/TeamOverviewComponent';
import { AuthContext } from '../auth/AuthContext';
import '../global.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const CoachDashboardPage = () => {
  const { token } = useContext(AuthContext);
  const [teams, setTeams] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [newTeamName, setNewTeamName] = useState('');
  const [showInput, setShowInput] = useState(false);

  const fetchTeamsAndPlayers = async () => {
    try {
      const teamRes = await fetch('https://vballbackend.onrender.com/api/teams', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const teamData = await teamRes.json();
      const rawTeams = teamData.teams;

      const enrichedTeams = await Promise.all(
        rawTeams.map(async (team) => {
          const playerRes = await fetch(`https://vballbackend.onrender.com/api/team/${team.id}/players`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          const json = await playerRes.json();
          return {
            ...team,
            team_name: json.team_name,
            players: Array.isArray(json.players) ? json.players : []
          };
        })
      );

      setTeams(enrichedTeams);
    } catch (error) {
      console.error("Error loading dashboard:", error);
    }
  };

  useEffect(() => {
    if (!token) return;
    fetchTeamsAndPlayers();
  }, [token]);

  const handleCreateTeam = async () => {
    if (newTeamName.length < 10 || newTeamName.length > 100) {
      alert("Team name must be between 10 and 100 characters.");
      return;
    }

    const confirmed = window.confirm(`Create new team: "${newTeamName}"?`);
    if (!confirmed) return;

    try {
      const res = await fetch('https://vballbackend.onrender.com/api/createteam', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ teamName: newTeamName })
      });

      const data = await res.json();

      if (!res.ok) {
        alert(`Failed to create team: ${data.msg}`);
      } else {
        alert('Team created!');
        setNewTeamName('');
        setShowInput(false);
        fetchTeamsAndPlayers();
      }
    } catch (error) {
      alert("Server error while creating team.");
      console.error(error);
    }
  };

  const filteredTeams = teams.filter(team =>
    team.team_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container" style={{ paddingTop: '2rem' }}>
      <h1 className="mb-4">Your Teams</h1>

      {/* Search + Create Button */}
      <div className="flex-row mb-4" style={{ gap: '1rem', alignItems: 'center' }}>
        <input
          type="text"
          placeholder="Search by team name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-grow"
          style={{
            padding: '0.5rem',
            border: '1px solid #D1D5DB',
            borderRadius: '0.375rem',
            fontSize: '1rem'
          }}
        />
        <button className="btn-primary" onClick={() => setShowInput(!showInput)}>
          {showInput ? 'Cancel' : '+ Create Team'}
        </button>
      </div>

      {/* Input Field */}
      {showInput && (
        <div className="flex-row" style={{ gap: '1rem', marginBottom: '1.5rem' }}>
          <input
            type="text"
            placeholder="Team name (10–100 chars)"
            value={newTeamName}
            onChange={(e) => setNewTeamName(e.target.value)}
            style={{ flexGrow: 1, padding: '8px' }}
          />
          <button onClick={handleCreateTeam}>Create Team</button>
        </div>
      )}

      {/* Teams List */}
      {filteredTeams.length === 0 ? (
        <p className="text-muted" style={{ fontStyle: 'italic' }}>
          No teams match your search.
        </p>
      ) : (
        <div className="flex-col" style={{ gap: '2rem' }}>
          {filteredTeams.map((team) => (
            <TeamOverviewComponent
              key={team.id}
              team={team}
              onDelete={fetchTeamsAndPlayers}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CoachDashboardPage;
